import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { AuthService } from 'src/app/auth/auth.service';
import { DashboardService } from '../dashboard.service';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { MerchantTransactionSearch } from 'src/app/models/merchant-transactions';
import * as moment from 'moment';
import { emptyFields, TransactionAccountTypes } from 'src/app/utilities/common-file';
import { countries } from 'src/app/utilities/countries';
import { CommonService } from 'src/app/utilities/common-service';
@Component({
  selector: 'app-dashboard-analytics',
  templateUrl: './dashboard-analytics.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class DashboardAnalyticsComponent implements OnInit {
  emptyField = emptyFields;
  countries = countries;
  transactionType = TransactionAccountTypes;
  todayDate: string;
  todayDay: string;
  merchantId: any;
  locationId: any;
  selectedMerchant: any;
  selectedLocation: any;
  appCode: string;

  // For QR Modal
  tplModal: NzModalRef;
  elementType: 'url' | 'canvas' | 'img' = 'url';
  QRJSON: any;
  qrValue: string;
  selectedQRValue: any;
  isVisible = false;

  // For Locations
  locationsList1 = [];
  locationsList = [];
  unClaimedTransactions = 0;
  settlementAmount = 0;
  loadingForLocation = false;
  loadingTextForLocation = '';
  showNoDataForLocations = false;

  // For Transactions
  recentData = [];
  loadingForTransaction = false;
  loadingTextForTransaction = '';
  showNoDataForTransactions = false;

  // tslint:disable-next-line: max-line-length
  private tableData: NzTableData<MerchantTransactionSearch, any> = new NzTableData<MerchantTransactionSearch, any>(new MerchantTransactionSearch(), 'transactionStatus');
  constructor(

    private modal: NzModalService,
    private authService: AuthService,
    private dashboardService: DashboardService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.todayDate = moment().local().format('DD MMM');
    this.todayDay = moment().local().format('ddd');
    this.merchantId = this.authService.getMerchantId();
    this.locationId = this.authService.getLocationId();
    this.appCode = this.authService.getAppCode();
    this.getMerchant();
    this.tableData.search.accountType = '';
    this.recentTransactions();
  }

  // For Merchant Details
  getMerchant() {
    this.selectedMerchant = this.authService.getMerchantDetails();
    this.getDailySummaryReport();
  }

  // For Locations List
  getLocation() {
    this.loadingForLocation = true;
    this.loadingTextForLocation = 'Loading';
    this.showNoDataForLocations = false;
    const value = {
      appCode: this.appCode,
      merchantId: this.merchantId,
      id: this.locationId ? this.locationId : ''
      };
    this.dashboardService.getLocationInfo(value).subscribe((response: any) => {
      this.loadingForLocation = false;
      this.loadingTextForLocation = '';
      this.showNoDataForLocations = false;
      for(let location of response.data.locations){
        var index = this.locationsList1.findIndex(m => m.locationId === location.id);
        if(index !== -1){
          location.transactionAmount = this.locationsList1[index].calculatedTotalAmount
          location.transactionCount = this.locationsList1[index].transactionCount
        }else{
          location.transactionAmount = 0;
          location.transactionCount = 0;
        }
        this.locationsList.push(location);
      }
      this.setQRJsonData();
      }, err => {
        this.locationsList1 = [];
        this.loadingForLocation = false;
        this.loadingTextForLocation = '';
        this.showNoDataForLocations = true;
      });
  }

getDailySummaryReport(){
  this.locationsList1 = [];
  this.loadingForLocation = true;
  this.loadingTextForLocation = 'Loading';
  this.showNoDataForLocations = false;
  const value = {
      appCode: this.appCode,
      merchantId: this.merchantId,
      locationId: this.locationId ? this.locationId : '',
      startDate : moment().startOf('day').toISOString(),
      endDate : moment().endOf('day').toISOString()
    };
  this.dashboardService.getDailyMerchantTransactionsWithLimit(value).subscribe((response: any) => {
    this.locationsList1 = response.data.merchantSummaryReportTransactions;
    this.getLocation();
    }, err => {
      this.locationsList1 = [];
      this.getLocation();
     
    });
}

// For Setting QR value
setQRJsonData() {
  for (const obj of this.locationsList) {
    this.QRJSON = {
            type: 'MERCHANT',
            locationId: obj.id,
            currency: this.selectedMerchant.currency,
            merchantId: this.merchantId,

            // For Mobile Side fix
            location_id: obj.id,
            merchant_id: this.merchantId,
    };
    obj.qrValue = JSON.stringify(this.QRJSON);
  }
}

// For Showing recent 10 transactions
  recentTransactions() {
    this.loadingForTransaction = true;
    this.showNoDataForTransactions = false;
    this.loadingTextForTransaction = 'Loading';
    this.tableData.search.appCode = this.appCode;
    this.tableData.search.locationId = this.locationId;
    this.tableData.search.merchantId = this.merchantId;
    this.dashboardService.getTransactionsWithLimit(this.tableData).subscribe((response: any) => {
      this.tableData.total = response.data.total;
      this.recentData = response.data.transactions;
      this.loadingForTransaction = false;
      this.showNoDataForTransactions = false;
      this.loadingTextForTransaction = '';
      }, err => {
        this.recentData = [];
        this.loadingForTransaction = false;
        this.showNoDataForTransactions = true;
        this.loadingTextForTransaction = '';
      });
  }
  // Open QR Modal
  showModal(qrValue) {
    this.isVisible = true;
    this.selectedQRValue = qrValue;
  }

  // Close QR Modal
  handleCancel(): void {
    this.isVisible = false;
    this.selectedQRValue = '';
  }
  // For getting transaction type
  getTransactionType(mode) {
    return this.commonService.getTransactionAccountType(mode);
  }
  // For Getting currency Symbol
  getCurrency(currency) {
    const index = this.countries.findIndex(M => M.currency_code ===  currency);
    if (index !== -1) {
        return this.countries[index].currency_symbol;
    } else {
      return '';
    }
  }
  getUserNameForPaynow(narration: string) {
    var paynow;
    if(narration){
      paynow = narration.startsWith("Merchant Pay, Paynow") || narration.startsWith("Settlement")|| narration.startsWith("Monthly Transfer Fee");
      return paynow;
    }else{
      return false;
    }        
  }
  // To Show First Letter of User's display name
  getLetterIcon(name) {
    if (name) {
      return name.charAt(0);
    } else {
      return '';
    }
  }
}